// extracted by mini-css-extract-plugin
export default {"dropdown-list":"Dropdown_dropdown-list__7K+hR"};